// Module
var code = "<div class=\"dms-parent-child\">\r\n    <div class=\"dms-content-header\"></div>\r\n    <div class=\"dms-content-wrapper\">\r\n        <div class=\"dms-parent\">\r\n            <div class=\"dms-content-container\"></div>\r\n        </div>\r\n        <div class=\"dms-child\"></div>\r\n    </div>\r\n</div>\r\n";
// Exports
export default code;